/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import {Component, Prop, Vue} from 'vue-property-decorator';
import {Sketch} from 'vue-color';
import {UgcBuildInterface} from '@/store/modules/ugc-build/types';
import {ColorChangerResponse} from '@/components/FlexiColourStrip/types';

/**
 * FlexiColour strip component.
 *
 * This component is used to display and modify flexi-colour selection in revision.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component({
    name: 'c-flexicolour-strip',
    components: {
        'colour-picker': Sketch,
    },
})
export default class FlexiColourStrip extends Vue {
    @Prop(Object) public build!: UgcBuildInterface;
    @Prop(Boolean) public interactive!: boolean;

    public readonly DEFAULT_COLOUR: string = '#FFFFFF';

    public color: string = this.DEFAULT_COLOUR;
    public selectedColor: ColorChangerResponse|undefined;
    public applyFlexiColor: (params: ColorChangerResponse) => void = ({}) => undefined;
    public changeFlexiColor: (params: ColorChangerResponse) => void = ({}) => undefined;

    /**
     * Show the color picker.
     *
     * @param {string} flexiColourName
     */
    public showColorPicker(flexiColourName: string): void {
        if (!this.interactive) {
            return;
        }

        this.color = !!this.build[flexiColourName] ? this.build[flexiColourName] as string : this.DEFAULT_COLOUR;
        this.selectedColor = {
            hex: !!this.build[flexiColourName] ? this.build[flexiColourName] as string : this.DEFAULT_COLOUR,
        };

        this.applyFlexiColor = (): void => {
            this.build[flexiColourName] = this.DEFAULT_COLOUR;
            if (undefined !== this.selectedColor && 0 !== this.selectedColor.a) {
                this.build[flexiColourName] = this.selectedColor.hex;
            }

            this.$modal.hide('color-picker');
        };

        this.changeFlexiColor = (colour: ColorChangerResponse): void => {
            this.selectedColor = colour;
        };

        this.$modal.show('color-picker');
    }

    /**
     * Format flexicolour selection.
     *
     * @param {string} flexicolor
     *
     * @returns {string}
     */
    public formatFlexiColor(flexicolor: string): string {
        if (flexicolor.match(/^[#][a-f\d]{6}$/i)) {
            return flexicolor;
        }

        return '#FFFFFF';
    }
}

